import { Trans } from 'react-i18next';
import { Text } from '@hotjar/hotsauce';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import { capitalize } from '@hotjar/insights-common/lib/string';

interface PlanDetailsProps {
  plan?: FeatureGroup;
  inTrial?: boolean;
  daysRemaining?: number;
}

export function DefaultFeaturesHeading({
  daysRemaining,
  inTrial,
  plan,
}: PlanDetailsProps): JSX.Element | null {
  const planName = capitalize(plan || '');
  return inTrial && daysRemaining ? (
    <Trans
      i18nKey="activation:dashboard.post-install-card.plan-trial-details-title"
      values={{ trialLength: daysRemaining, plan: planName }}
    >
      We also unlocked a free{' '}
      <Text textType="subtitle2" as="span">
        {daysRemaining}-day trial of Hotjar {planName}
      </Text>
      , which includes:
    </Trans>
  ) : (
    <Trans
      i18nKey="activation:dashboard.post-install-card.plan-details-title"
      values={{ plan: planName }}
    >
      On your Hotjar {planName} plan:
    </Trans>
  );
}

export type { PlanDetailsProps };
